/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{g as r}from"../chunks/geometryEngineJSON.js";function e(e){return(0,r[e.operation])(...e.parameters)}export{e as executeGEOperation};
